import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBook, FiHeart, FiStar } = FiIcons;

const Header = () => {
  return (
    <motion.header 
      className="bg-white shadow-lg border-b-4 border-purple-200"
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-center space-x-3">
          <motion.div
            animate={{ rotate: [0, 5, -5, 0] }}
            transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}
          >
            <SafeIcon icon={FiBook} className="text-4xl text-purple-600" />
          </motion.div>
          <div className="text-center">
            <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              BookBlurb Pro
            </h1>
            <p className="text-gray-600 mt-2 flex items-center justify-center space-x-2">
              <SafeIcon icon={FiHeart} className="text-red-500" />
              <span>Craft compelling descriptions that honor God and captivate readers</span>
              <SafeIcon icon={FiStar} className="text-yellow-500" />
            </p>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;